import type { FC } from "react";
import { Badge, BadgeStyle } from "./Badge";

export const AssessmentTypeBadge: FC<{ type: "exam" | "inspection" }> = (props) => {
  const styleMapping = {
    exam: BadgeStyle.info,
    inspection: BadgeStyle.success,
    Geen: BadgeStyle.default,
  };
  const textMapping = {
    exam: "Competency Test",
    inspection: "Inspectie",
    Onbekend: BadgeStyle.default,
  };

  return (
    <Badge style={styleMapping[props.type ?? "Geen"]}>
      {textMapping[props.type ?? "Onbekend"]}
    </Badge>
  );
};
